// extracted by mini-css-extract-plugin
export default {"root":"_1Ac8q1f3Gd0TU_JqFI23ep","headerButton":"_2zYoMf4Q4glVkLYe0Yjfc_","logo":"_2EW5K1vHiMvdid_zFi0uFP","backButton":"GDhlrtqU1-y3xKW3G_KJA"};